import React from 'react';

// Import custom Components 
import Homepage from '../components/dashboard/home';
import PortalUser from '../components/dashboard/PortalUser';
import EmployeeUser from '../components/dashboard/EmployeeUser';
import Settings from '../components/dashboard/Settings';
import ConsolidateFile from '../components/dashboard/Consolidate';
import EmployeeProfile from '../components/dashboard/EmployeeProfile';
import Notification from '../components/dashboard/Notifications';
export const routes = [
    { path: `/dashboard`, Component: <Homepage /> },
    { path: `/portalUser`, Component: <PortalUser /> },
    { path: `/employee`, Component: <EmployeeUser /> },
    { path: `/settings`, Component: <Settings /> },
    { path: `/notification`, Component: <Notification /> },
    { path: `/transactions`, Component: <ConsolidateFile /> },
    { path: `/profile/:id`, Component: <EmployeeProfile /> },
]
